import { Skeleton } from '@mui/lab'
import { Chip } from '@mui/material'
import { connect, useDispatch } from 'react-redux'
import { createNotification } from 'react-redux-notify'
import { Table, Overlay, Button } from 'react-bootstrap'
import React, { useEffect, useState, useRef } from 'react'

import { useQRCodeModal } from '../../hooks/useQRCodeModal'
import { formatTransactiontDate } from '../../helpers/date/date'
import WalletService from '../../helpers/services/payment/wallet'
import { fetchWalletHistoryStart } from '../../store/actions/WalletAction'
import { parsePaymentServiceError } from '../../helpers/services/payment/error'
import { getErrorNotificationMessage } from '../../components/helper/NotificationMessage'

import NothingHere from '../../images_new/icon/nothing_here.svg?react'
import VerticalMenu from '../../images_new/icon/menu-vertical.svg?react'

const Statement = (props) => {
  const { walletHistory } = props

  const dispatch = useDispatch()
  const { showQRCodeModal, QRCodeModal } = useQRCodeModal()

  const [showMenu, setShowMenu] = useState(false)
  const [menuTarget, setMenuTarget] = useState(null)
  const [selectedWallet, setSelectedWallet] = useState(null)
  const menuTargetRef = useRef(null)


  useEffect(() => {
    dispatch(fetchWalletHistoryStart())
  }, [])

  const getStatusColor = (status) => {
    if (status === 'COMPLETED') return 'success'
    if (status === 'FAILED') return 'error'
    if (status === 'PENDING') return 'warning'
    return 'info'
  }

  const toggleMenu = (event, wallet) => {
    setMenuTarget(event.target)
    setSelectedWallet(wallet)
    setShowMenu((prevState) => !prevState)
  }

  const handlePendingClick = async (payment) => {
    try {
      const result = await WalletService.fetchCryptoHostedUrl(payment.user_wallet_payment_unique_id)
      if (result?.data) {
        showQRCodeModal(
          result.data.hosted_url,
          result.data.expires_at,
          payment.requested_amount_formatted,
          result.data.is_in_test_mode
        )
      }
    } catch (error) {
      const message = parsePaymentServiceError(error.response);
      dispatch(createNotification(getErrorNotificationMessage(message || 'Failed to fetch payment details')))
    } finally {
      setShowMenu(false)
    }
  }

  return (
    <>
      <div className='security statement last-card-margin'>
        <div className='trans-table-sec'>
          <div className='trans-table'>
            {walletHistory?.data?.history?.length ? (
              <Table className='wallet-table' bordered={false} borderless={true} responsive='true'>
                <thead className='wallet-table-head'>
                  <tr>
                    <th>DATE & TIME</th>
                    <th>DESCRIPTION</th>
                    <th>AMOUNT</th>
                    <th>STATUS</th>
                    <th>FEE</th>
                    <th>NET</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {walletHistory?.data?.history?.map((wallet) => {
                    const isPending = wallet.payment_mode === 'Crypto' && wallet.status_formatted === 'PENDING' 
                    return(
                    <tr key={wallet.payment_id} className={wallet.status === 6 ? 'tr-failed' : ''}>
                      <td>
                        <p className='m-0 p-0'>{formatTransactiontDate(wallet.paid_date)}</p>
                      </td>
                      <td>
                        <span dangerouslySetInnerHTML={{ __html: wallet.message }}></span>
                      </td>
                      <td>{wallet.requested_amount_formatted}</td>
                      <td style={{ cursor : isPending ? 'pointer' : 'default'}}>
                        <Chip
                          label={wallet.status_formatted}
                          color={getStatusColor(wallet.status_formatted)}
                          size='small'
                          variant='outlined'
                          sx={{ borderRadius: '6px' }}
                          style={{ cursor : isPending ? 'pointer' : 'default'}}
                        />
                      </td>
                      <td>{wallet.usage_type == 'wallet_load' ? wallet.processing_fee_formatted : wallet.admin_amount_formatted}</td>
                      <td> {wallet.user_amount_formatted} </td>
                      <td>
                        <div ref={menuTargetRef}>
                          <VerticalMenu
                            role={'button'}
                            aria-label='vertical menu'
                            className={'vertical-menu-icon'}
                            onClick={(e) => toggleMenu(e, wallet)}
                          />
                          <Overlay
                            target={menuTarget}
                            show={showMenu && selectedWallet?.payment_id === wallet.payment_id}
                            placement='bottom-end'
                            rootClose={true}
                            rootCloseEvent='click'
                            container={menuTargetRef}
                            onHide={() => setShowMenu(false)}
                          >
                            {({ placement, arrowProps, show: _show, popper, ...props }) => (
                              <div {...props} className='shadow post-menu-container'>
                                {isPending && (
                                  <Button 
                                    className='border-0 post-menu-button'
                                    onClick={() => handlePendingClick(wallet)}
                                  >
                                    Check Payment
                                  </Button>
                                )}
                              </div>
                            )}
                          </Overlay>
                        </div>
                      </td>
                    </tr>
                  )})}
                </tbody>
              </Table>
            ) : (
              <>
                <Table
                  className='last-card-margin'
                  bordered={false}
                  borderless={true}
                  responsive='true'
                >
                  <thead>
                    <tr>
                      <th>DATE & TIME</th>
                      <th>DESCRIPTION</th>
                      <th>AMOUNT</th>
                      <th>STATUS</th>
                      <th>FEE</th>
                      <th>NET</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(8).keys()].map((item) => (
                      <tr key={item}>
                        {walletHistory.loading
                          ? [...Array(5).keys()].map((item) => (
                            <td key={item}>
                              <Skeleton animation='wave' variant='text' />
                            </td>
                          ))
                          : ''}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className='mt-5 nothing_here d-flex justify-content-center align-items-center'>
                  {walletHistory.loading ? '' : <NothingHere />}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <QRCodeModal />
    </>
  )
}

const mapStateToPros = (state) => ({
  userData: state.users,
  walletHistory: state.wallet.walletHistory,
})

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

export default connect(mapStateToPros, mapDispatchToProps)(Statement)
